export default __webpack_public_path__ + "static/media/Logo-Deimare.25469b95.png";